import {
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faCircleExclamation,
  faCircleInfo,
  faPenToSquare,
  faSearch,
  faTrash,
  faXmark,
  faArrowRight,
  faTriangleExclamation,
  faCheck,
  faArrowUpRightFromSquare,
  faPersonCircleCheck,
  faArrowsTurnToDots,
  faPlane,
  faEuroSign,
  faCreditCard,
  faList,
  faUser,
  faBars,
  faUserGear,
  faFileInvoiceDollar,
  faGlobeEurope,
  faHome,
  faQuestion,
  faArrowRightFromBracket,
  faChevronLeft,
  faChevronRight,
  faGlobe,
  faLayerGroup,
  faEnvelope,
  faPlus,
  faChevronUp,
  faChevronDown,
  faCircle,
  faClose,
  faCar,
  faMoneyCheckDollar,
  faGears,
  faUsers,
  faCoins,
  faTicket,
  faUserGraduate,
} from "@fortawesome/free-solid-svg-icons";

import { BugReport } from "@mui/icons-material";

const Icons = {
  circle: faCircle,
  check: faCheck,
  arrowLeft: faArrowLeft,
  penToSquare: faPenToSquare,
  circleInfo: faCircleInfo,
  arrowDown: faArrowDown,
  arrowUp: faArrowUp,
  arrowRight: faArrowRight,
  trash: faTrash,
  circleExclamation: faCircleExclamation,
  search: faSearch,
  close: faClose,
  xmark: faXmark,
  triangleExclamation: faTriangleExclamation,
  arrowUpRightFromSquare: faArrowUpRightFromSquare,
  arrowsTurnToDots: faArrowsTurnToDots,
  personCircleCheck: faPersonCircleCheck,
  plane: faPlane,
  euroSign: faEuroSign,
  creditCard: faCreditCard,
  list: faList,
  user: faUser,
  bars: faBars,
  userGear: faUserGear,
  fileInvoiceDollar: faFileInvoiceDollar,
  globeEurope: faGlobeEurope,
  globe: faGlobe,
  home: faHome,
  question: faQuestion,
  arrowRightFromBracket: faArrowRightFromBracket,
  chevronLeft: faChevronLeft,
  chevronUp: faChevronUp,
  chevronDown: faChevronDown,
  chevronRight: faChevronRight,
  layerGroup: faLayerGroup,
  envelope: faEnvelope,
  plus: faPlus,
  bugReport: BugReport,
  // TODO rename icons in contacts to maintain naming consistency
  car: faCar,
  "fa-money-bill-alt": faMoneyCheckDollar,
  "fa-cogs": faGears,
  "fa-coins": faCoins,
  "fa-users": faUsers,
  "fa-user-gear": faUserGear,
  "fa-ticket": faTicket,
  "fa-user-graduate": faUserGraduate,
};

export default Icons;
